import { render, staticRenderFns } from "./PopupSignup.vue?vue&type=template&id=e3b48920&"
import script from "./PopupSignup.vue?vue&type=script&lang=js&"
export * from "./PopupSignup.vue?vue&type=script&lang=js&"
import style0 from "./PopupSignup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports